import type React from 'react';

import { withStyles } from '@material-ui/core';
import BaseFormControlLabel, {
  type FormControlLabelProps as BaseFormControlLabelProps,
} from '@material-ui/core/FormControlLabel';

import { colors, fonts } from '../styles';

const FormControlLabelStyled = withStyles({
  root: {
    margin: 0,
  },
  label: {
    color: colors.gray.dark,
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.medium,
    lineHeight: 1.36,
  },
  disabled: {
    '&&': {
      color: colors.gray.default,
      cursor: 'not-allowed',
    },
  },
})(BaseFormControlLabel);

export const FormControlLabel: React.ComponentType<BaseFormControlLabelProps> =
  (props) => {
    return <FormControlLabelStyled {...props} />;
  };
